import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates/crudBuilder/models/CrudBuilderState";

import {
  childAssignmentsStateConfig,
  childAssignmentStateConfig,
  currentAssignmentsStateConfig
} from "../consts";

export type StudentAssignmentsMetaState = CrudBuilderState;

export const defaultStudentAssignmentsMetaState = makeCrudBuilderInitialState(
  currentAssignmentsStateConfig
);

export const defaultChildAssignmentsMetaState = makeCrudBuilderInitialState(
  childAssignmentsStateConfig
);

export const defaultChildAssignmentMetaState = makeCrudBuilderInitialState(
  childAssignmentStateConfig
);

export type AssignmentMetaType = {
  futureAssignments: StudentAssignmentsMetaState | Map<any, any>;
  pastAssignments: StudentAssignmentsMetaState | Map<any, any>;
  childAssignments: StudentAssignmentsMetaState | Map<any, any>;
  childAssignment: StudentAssignmentsMetaState | Map<any, any>;
};

const defaultAssignmentMeta: AssignmentMetaType = {
  futureAssignments: defaultStudentAssignmentsMetaState,
  pastAssignments: defaultStudentAssignmentsMetaState,
  childAssignments: defaultChildAssignmentsMetaState,
  childAssignment: defaultChildAssignmentMetaState
};

export default class AssignmentMeta extends Record(defaultAssignmentMeta) {}
